import styled from 'styled-components';

export const SecondaryButton = styled.button`
  margin: ${({ theme }) => theme.buttonSecondaryMargin};
  padding: ${({ theme }) => theme.buttonSecondaryPadding};
  font-size: ${({ theme }) => theme.buttonSecondaryFontSize};
  font-family: ${({ theme }) => theme.buttonSecondaryFontFamily};
  color: ${({ theme }) => theme.buttonSecondaryColor};
  background-color: ${({ theme }) => theme.buttonSecondaryBackgroundColor};
  border: ${({ theme }) => theme.buttonSecondaryBorder};
  border-radius: ${({ theme }) => theme.buttonSecondaryBorderRadius};
  cursor: pointer;
`;
